import React from 'react';
import ScenarioList from '../components/ScenarioList';
import ScenarioAssignmentComponent from '../components/ScenarioAssignment';

export default function ScenariosPage() {
  return (
    <main className="bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Scénarios de Formation</h1>
          <p className="mt-2 text-gray-600">Gérez et assignez les scénarios aux élèves</p>
        </div>
        
        <ScenarioAssignmentComponent />
        <ScenarioList />
      </div>
    </main>
  );
}